import React, { useContext, useState } from 'react';
import closeFormIcon from '../images/close-message.svg';
import modalMinimizedIcon from '../images/modal-minimized.svg';
import minimizeModalIcon from '../images/minimize-modal.svg';
import './MainModal.css';
import { AppInfoContext } from '../../../../../App';
import LocationUpdate from '../problemmanagement/workorder/LocationUpdate';
import SelectElement from '../problemmanagement/workorder/SelectElement';

function MainModal({
  title,
  component: BodyComponent,
  closeModal,
  currentFormStep,
  increaseFormStep,
  decreaseFormStep,
  setFormStep,
  formInfo,
  setFormInfo,
  isMinimized,
  setIsMinimized,
  currentReportProblemFormStep,
}) {
  const { appInformation, setAppInformation } = useContext(AppInfoContext);

  const [modalAnimation, setModalAnimation] = useState('backOutRight');

  const updateProblemLocation = (newX, newY) => {
    setAppInformation((prevValue) => ({
      ...prevValue,
      problemManagement: {
        ...prevValue.problemManagement,
        location: { x: newX, y: newY },
        locationModal: false,
      },
    }));
  };

  const updateSelectedElement = (selectedOption) => {
    setAppInformation((prevValue) => ({
      ...prevValue,
      problemManagement: {
        ...prevValue.problemManagement,
        elementSelection: false,
        selectedElement: selectedOption,
      },
    }));
  };

  const toggleAnimation = () => {
    if (!isMinimized) {
      setModalAnimation('backInRight');

      setIsMinimized(true);
    } else {
      setModalAnimation('backOutRight');
      setTimeout(() => {
        setIsMinimized(false);
      }, 600);
    }
  };

  return (
    <>
      {!isMinimized && (
        <div
          className="main-modal "
          style={{
            display:
              !appInformation.problemManagement.locationModal &&
              !appInformation.problemManagement.elementSelection
                ? 'block'
                : 'none',
          }}
        >
          <div
            className={
              [2, 4, 7].includes(currentFormStep) ||
              [0, 1, 2, 3, 5].includes(currentReportProblemFormStep)
                ? 'main-modal-shadow main-modal-shadow-confirmation '
                : 'main-modal-shadow'
            }
            onClick={closeModal}
          ></div>

          <div className="main-modal-container">
            <div className="main-modal-header">
              <div className="mm-header-title">{title}</div>

              <div style={{ display: 'flex', gap: '5px' }}>
                <button
                  style={{ fontWeight: 'bolder' }}
                  className="mm-header-close-button"
                  onClick={() => {
                    toggleAnimation();
                  }}
                >
                  <img
                    src={minimizeModalIcon}
                    style={{ height: '10px', width: '10px', marginTop: '1px' }}
                    alt="Icon"
                  />
                </button>

                <button
                  style={{ fontWeight: 'bolder' }}
                  className="mm-header-close-button"
                  onClick={closeModal}
                >
                  <img
                    src={closeFormIcon}
                    style={{ height: '10px' }}
                    alt="Icon"
                  />
                </button>
              </div>
            </div>

            <div className="main-modal-body">
              <BodyComponent
                increaseFormStep={increaseFormStep}
                decreaseFormStep={decreaseFormStep}
                setFormStep={setFormStep}
                formInfo={formInfo}
                setFormInfo={setFormInfo}
                closeModal={closeModal}
              />
            </div>
          </div>
        </div>
      )}

      {appInformation.problemManagement.locationModal && (
        <LocationUpdate updateProblemLocation={updateProblemLocation} />
      )}

      {appInformation.problemManagement.elementSelection && (
        <>
          <SelectElement
            layerName={`gracanica:${appInformation.problemManagement.selectedLayer}`}
            updateSelectedElement={updateSelectedElement}
          />
        </>
      )}

      {isMinimized && (
        <div
          className={`minimized-main-modal ${modalAnimation}`}
          onClick={() => {
            toggleAnimation();
          }}
        >
          <img src={modalMinimizedIcon} style={{ height: '20px' }} alt="Icon" />
        </div>
      )}
    </>
  );
}

export default MainModal;
